import { Body1 } from '@cian/ui-kit';

import { IconActionChevronLeft16 } from '@cian/ui-kit-design-tokens/icons';

import * as styles from './styles.css';

export interface IBackToPageProps {
  text: string;
  href: string;
  onClick?(): void;
}

export function BackToPage({ text, href, onClick }: IBackToPageProps) {
  return (
    <div className={styles['container']}>
      <a href={href} className={styles['link']} onClick={onClick} title={text}>
        <IconActionChevronLeft16 color="current_color" />{' '}
        <span>
          <Body1 color="current_color" display="inline">
            {text}
          </Body1>
        </span>
      </a>
    </div>
  );
}
